import { useState } from "react"
import { PiMagnifyingGlassDuotone } from 'react-icons/pi'

import Modal from "../../shared/modal/Modal"
import CfopSearchModal from './CfopSearchModal'

// Reaproveita o CSS do trigger de NCM — mesmo visual de input+botão colado.
import '../../shared/css/inputGroup.css'

// Campo de CFOP com um botão de busca colado — abre um modal de busca na tabela
// oficial embutida (ver CfopSearchModal.js / backend/data/cfopCatalog.js).
function CfopSearchTrigger({ name, value, handleOnChange, onSelect }) {
    const [modalCfop, setModalCfop] = useState(false)

    function handlePicked(c) {
        onSelect(c)
        setModalCfop(false)
    }

    return (
        <>
            <div className="ncm-input-group">
                <input className="input ncm-input-group-input" type="text" name={name} value={value || ''} onChange={handleOnChange} />
                <button type="button" className="ncm-input-group-btn" title="Buscar CFOP" onClick={() => setModalCfop(true)}>
                    <PiMagnifyingGlassDuotone size={23} />
                </button>
            </div>

            <Modal
                modalStatus={modalCfop}
                changeStatus={setModalCfop}
                w={55}
                content={<CfopSearchModal onSelect={handlePicked} />}
            />
        </>
    )
}

export default CfopSearchTrigger
